'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _treeSelect = require('@alicd/next/lib/tree-select');

var _treeSelect2 = _interopRequireDefault(_treeSelect);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cruiFormItem = require('@alicd/crui-form-item');

var _cruiFormItem2 = _interopRequireDefault(_cruiFormItem);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TreeSelectField = function (_React$Component) {
  (0, _inherits3.default)(TreeSelectField, _React$Component);

  function TreeSelectField() {
    (0, _classCallCheck3.default)(this, TreeSelectField);
    return (0, _possibleConstructorReturn3.default)(this, (TreeSelectField.__proto__ || (0, _getPrototypeOf2.default)(TreeSelectField)).apply(this, arguments));
  }

  (0, _createClass3.default)(TreeSelectField, [{
    key: 'render',
    value: function render() {
      /* eslint-disable */
      var _props = this.props,
          bind = _props.bind,
          style = _props.style,
          inputStyle = _props.inputStyle,
          children = _props.children,
          init = _props.init,
          compact = _props.compact,
          treeCheckable = _props.treeCheckable,
          multiple = _props.multiple,
          other = (0, _objectWithoutProperties3.default)(_props, ['bind', 'style', 'inputStyle', 'children', 'init', 'compact', 'treeCheckable', 'multiple']);
      var labelCol = other.labelCol,
          wrapperCol = other.wrapperCol,
          mapping = other.mapping,
          className = other.className,
          otherInput = (0, _objectWithoutProperties3.default)(other, ['labelCol', 'wrapperCol', 'mapping', 'className']);
      /* eslint-enable */

      return _react2.default.createElement(
        _cruiFormItem2.default,
        (0, _extends3.default)({}, other, { style: style }),
        _react2.default.createElement(
          _treeSelect2.default,
          (0, _extends3.default)({}, otherInput, {
            style: inputStyle,
            treeCheckable: treeCheckable,
            multiple: multiple,
            className: (0, _classnames2.default)({
              'z-compact': compact && (treeCheckable || multiple)
            }) }),
          children
        )
      );
    }
  }]);
  return TreeSelectField;
}(_react2.default.Component);

exports.default = TreeSelectField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-tree-select-field@0.0.9@@alicd/crui-tree-select-field/lib/index.js
// module id = 728
// module chunks = 0